const ALLOWED_TAGS = new Set(['SPAN', 'BR', 'EM']);
const ALLOWED_CLASSES = new Set(['home-pasos__title-accent']);

const PASOS_MARKUP_PATTERN = /<(span|br|em)\b/i;

export function escapePasosHtml(text: string): string {
  return text
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

export function containsPasosMarkup(text: string): boolean {
  return PASOS_MARKUP_PATTERN.test(text);
}

/** Sanitiza HTML permitido para el título administrable de 4 pasos. */
export function sanitizePasosHtml(raw: string): string {
  const trimmed = raw.trim();
  if (!trimmed) {
    return '';
  }

  if (!containsPasosMarkup(trimmed)) {
    return escapePasosHtml(trimmed);
  }

  if (typeof DOMParser === 'undefined') {
    return escapePasosHtml(trimmed);
  }

  const doc = new DOMParser().parseFromString(trimmed, 'text/html');
  return serializeAllowedPasosNodes(doc.body).trim();
}

function serializeAllowedPasosNodes(parent: ParentNode): string {
  let html = '';

  parent.childNodes.forEach((node) => {
    if (node.nodeType === Node.TEXT_NODE) {
      html += escapePasosHtml(node.textContent ?? '');
      return;
    }

    if (node.nodeType !== Node.ELEMENT_NODE) {
      return;
    }

    const element = node as HTMLElement;
    const tag = element.tagName;

    if (!ALLOWED_TAGS.has(tag)) {
      html += serializeAllowedPasosNodes(element);
      return;
    }

    if (tag === 'BR') {
      html += '<br>';
      return;
    }

    const classes = [...element.classList].filter((className) =>
      ALLOWED_CLASSES.has(className)
    );
    const classAttr = classes.length ? ` class="${classes.join(' ')}"` : '';
    const tagName = tag.toLowerCase();

    html += `<${tagName}${classAttr}>${serializeAllowedPasosNodes(element)}</${tagName}>`;
  });

  return html;
}

export function preparePasosTitleHtml(raw: string): string {
  const trimmed = raw.trim();
  if (!trimmed) {
    return '';
  }

  if (containsPasosMarkup(trimmed)) {
    return sanitizePasosHtml(trimmed);
  }

  return escapePasosHtml(trimmed);
}
